// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
/* .tab-content:last-child {
  display: none;
} */
 
/* ==========================================================================
   #GRID
   ========================================================================== */
.row {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.row-space {
  justify-content: space-between;
}

.row-refine {
  margin: 0 -15px;
}

.col-2 {
  width: calc((100% - 30px) / 2);
}

@media (max-width: 767px) {
  .col-2 {
    width: 100%;
  }
}

/* ==========================================================================
   #BOX-SIZING
   ========================================================================== */
/**
 * More sensible default box-sizing:
 * css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice
 */
html {
  box-sizing: border-box;
}

* {
  padding: 0;
  margin: 0;
}

*, *:before, *:after {
  box-sizing: inherit;
}

/* ==========================================================================
   #RESET
   ========================================================================== */
/**
 * A very simple reset that sits on top of Normalize.css.
 */
body,
h1, h2, h3, h4, h5, h6,
blockquote, p, pre,
dl, dd, ol, ul,
figure,
hr,
fieldset, legend {
  margin: 0;
  padding: 0;
}

/**
 * Remove trailing margins from nested lists.
 */
li > ol,
li > ul {
  margin-bottom: 0;
}

/**
 * Remove default table spacing.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/**
 * 1. Reset Chrome and Firefox behaviour which sets a \`min-width: min-content;\`
 *    on fieldsets.
 */
fieldset {
  min-width: 0;
  /* [1] */
  border: 0;
}

 

/* ==========================================================================
   #PAGE WRAPPER
   ========================================================================== */
.page-wrapper {
  min-height: 100vh;
}

body {
   font-weight: 400;
  font-size: 14px;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
}

h1 {
  font-size: 36px;
}

h2 {
  font-size: 30px;
}

h3 {
  font-size: 24px;
}

h4 {
  font-size: 18px;
}

h5 {
  font-size: 15px;
}

h6 {
  font-size: 13px;
}

img {
  max-width: 100%;
  height: auto;
}

a {
  display: inline-block;
  text-decoration: none;
  transition: all 0.4s ease;
}

a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

/* ==========================================================================
   #BACKGROUND
   ========================================================================== */
.bg-img-1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center/cover no-repeat;
}

/* ==========================================================================
   #SPACING
   ========================================================================== */
.p-t-15 {
  padding-top: 15px;
}

.p-t-5 {
  padding-top: 5px;
}

.p-t-275 {
  padding-top: 275px;
}

@media (max-width: 767px) {
  .p-t-275 {
    padding-top: 120px;
  }
}

.p-t-165 {
  padding-top: 165px;
}

@media (max-width: 767px) {
  .p-t-165 {
    padding-top: 120px;
  }
}

.p-b-100 {
  padding-bottom: 100px;
}

@media (max-width: 767px) {
  .p-b-100 {
    padding-bottom: 250px;
  }
}

.m-r-45 {
  margin-right: 45px;
}

@media (max-width: 767px) {
  .m-r-45 {
    margin-right: 15px;
  }
}

.m-t-0 {
  margin-top: 0;
}

/* ==========================================================================
   #WRAPPER
   ========================================================================== */
.wrapper {
  margin: 0 auto;
}

.wrapper--w680 {
  max-width: 680px;
}

/* ==========================================================================
   #BUTTON
   ========================================================================== */
.btn-submit {
  display: block;
  margin-top: 32px;
  width: 100%;
  line-height: 50px;
  font-family: inherit;
  background: #00ad5f;
  text-transform: uppercase;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  transition: all 0.4s ease;
}

.btn-submit:hover {
  background: #00994b;
}

.m-t-0 {
  margin-top: 0;
}

/* ==========================================================================
   #DATEPICKER
   ========================================================================== */
.daterangepicker {
  display: none;
  width: 570px;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 30px 35px;
  padding-top: 27px;
  padding-bottom: 45px;
  margin-top: 2px;
}

@media (max-width: 767px) {
  .daterangepicker {
    width: calc(100% - 60px);
    padding: 25px 0px;
  }
}

.daterangepicker:before, .daterangepicker:after {
  display: none;
}

.daterangepicker .calendar {
  margin: 0;
  width: 235px;
}

.daterangepicker .calendar th {
  font-size: 14px;
  color: #aaa;
  cursor: default;
}

.daterangepicker .calendar th.month {
  font-size: 16px;
  color: #555;
  font-weight: 700;
}

.daterangepicker .calendar th.next, .daterangepicker .calendar th.prev {
  font-size: 20px;
  color: #ccc;
  text-align: center;
}

.daterangepicker .calendar.right {
  float: right;
}

@media (max-width: 767px) {
  .daterangepicker .calendar {
    width: 235px;
    max-width: 270px;
  }
  .daterangepicker .calendar.right, .daterangepicker .calendar.left {
    float: none !important;
    clear: none !important;
    margin: 0 auto !important;
  }
  .daterangepicker .calendar.left {
    margin-bottom: 30px !important;
  }
}

.daterangepicker .calendar-table {
  padding: 0;
}

.daterangepicker .calendar-table .table-condensed thead tr:nth-child(2) th {
  padding-top: 27px;
  padding-bottom: 17px;
}

.daterangepicker.ltr .calendar.left .calendar-table {
  padding: 0;
}

.daterangepicker_input {
  display: none;
}

.daterangepicker td {
  border-radius: 50%;
  height: 32px;
  width: 32px;
  font-family: "Lato", "Arial", "Helvetica Neue", sans-serif;
  text-align: center;
  font-size: 14px;
  color: #555;
}

.daterangepicker td.start-date, .daterangepicker td.end-date {
  border-radius: 50%;
  background: #ffa037;
}

.daterangepicker td.start-date.end-date {
  border-radius: 50%;
}

.daterangepicker td.in-range {
  background: #ffe1c4;
}

.daterangepicker td.today {
  border-radius: 50% !important;
  background: #c9c9c9;
}

.daterangepicker td.today.in-range {
  border-radius: 0 !important;
  background: #ffe1c4;
}

.daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {
  background: transparent;
  color: #aaa;
}

.daterangepicker select {
  outline: none;
  font-family: inherit;
}

.daterangepicker select.monthselect, .daterangepicker select.yearselect {
  font-size: 14px;
  padding: 8px 4px;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background: #ffa037;
}

.dropdown-datepicker {
  position: relative;
}

.dropdown-datepicker .daterangepicker {
  width: 270px;
  padding: 20px;
}

/* ==========================================================================
   #FORM
   ========================================================================== */
input,
textarea {
  outline: none;
  margin: 0;
  border: none;
  box-shadow: none;
  width: 100%;
  font-size: 18px;
  font-family: inherit;
}

input:disabled {
  background: transparent;
  cursor: pointer;
}

textarea {
  resize: none;
}

button {
  cursor: pointer;
}

.input-group {
  position: relative;
  border-bottom: 2px solid #cccccc !important;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  font-size: 24px;
  color: #808080;
  position: absolute;
  line-height: 44px;
  right: 0;
  top: 0;
  width: 42px;
  background: #fff;
  text-align: center;
  cursor: pointer;
}

.input-icon::before {
  display: block;
  transition: all 0.4s ease;
}

.label {
  font-size: 12px;
  color: #999;
  text-transform: uppercase;
  display: block;
  margin-bottom: -3px;
  font-weight: 700;
  text-align: left;
}

.input--style-1 {
  font-weight: 700;
  font-size: 18px;
  padding: 11px 0;
  color: #555555;
}

.input--style-1::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #555;
}

.input--style-1:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #555;
  opacity: 1;
}

.input--style-1::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #555;
  opacity: 1;
}

.input--style-1:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #555;
}

.input--style-1:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #555;
}

/* CHECKBOX */
.checkbox-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 15px;
  color: #666;
  -webkit-user-select: none;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 2px solid #ccc;
  border-radius: 3px;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: transparent;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 4px;
  top: 2px;
  width: 7px;
  height: 10px;
  border: solid #00ad5f;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

/* ==========================================================================
   #SELECT
   ========================================================================== */
.quantity {
  display: flex;
  float: right;
}

@media (max-width: 575px) {
  .quantity {
    float: none;
    margin-top: 10px;
  }
}

.quantity > input {
  -webkit-appearance: none;
  width: 55px;
  text-align: center;
  font-size: 18px;
  color: #555;
  font-weight: 700;
}

.minus,
.plus {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 26px;
  text-align: center;
  border: 2px solid #ccc;
  font-size: 24px;
  color: #ccc;
  border-radius: 50%;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  transition: all 0.4s ease;
}

.minus:hover,
.plus:hover {
  background: #ccc;
  color: #fff;
}

.list-room {
  list-style: none;
  max-height: 324px;
  overflow-y: auto;
  padding-right: 20px;
}

.list-room__item {
  margin-bottom: 20px;
}

.list-room__footer {
  padding-top: 22px;
  border-top: 1px solid #e5e5e5;
}

.list-room__name {
  margin-bottom: 27px;
  display: block;
  font-weight: 700;
  color: #999;
}

.list-person {
  list-style: none;
}

.list-person .list-person__item:last-child {
  margin-bottom: 0;
}

.list-person__item {
  margin-bottom: 34px;
}

.list-person__item::after {
  content: "";
  clear: both;
  display: table;
}

.list-person__item .name {
  font-size: 18px;
  color: #555;
  font-weight: 700;
  display: inline-block;
  margin-top: 5px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#btn-add-room {
  font-family: inherit;
  font-size: 16px;
  color: #00ad5f;
  font-weight: 700;
  transition: all 0.4s ease;
}

#btn-add-room:hover {
  text-decoration: underline;
}

.dropdown-select {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 2px);
  background: #fff;
  z-index: 999;
  border-radius: 10px;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);
  padding: 30px 45px;
  padding-right: 25px;
}

.dropdown-select.show {
  display: block;
}

.open .input-icon::before {
  transform: rotate(-180deg);
}

/* ==========================================================================
   #SELECT2
   ========================================================================== */
.select--no-search .select2-search {
  display: none !important;
}

.rs-select2 {
  width: 100%;
}

.rs-select2 .select2-container {
  width: 100% !important;
  outline: none;
}

.rs-select2 .select2-container .select2-selection--single {
  outline: none;
  border: none;
  height: 44px;
}

.rs-select2 .select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 44px;
  padding-left: 0;
  color: #555;
  font-size: 18px;
  font-weight: 700;
}

.rs-select2 .select2-container .select2-selection--single .select2-selection__arrow {
  height: 44px;
  right: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rs-select2 .select2-container .select2-selection--single .select2-selection__arrow b {
  display: none;
}

.rs-select2 .select2-container .select2-selection--single .select2-selection__arrow:after {
  font-family: "Material-Design-Iconic-Font";
  content: '\\f2f9';
  font-size: 24px;
  color: #808080;
  transition: all 0.4s ease;
}

.rs-select2 .select2-container.select2-container--open .select2-selection--single .select2-selection__arrow::after {
  transform: rotate(-180deg);
}

.select2-container--open .select2-dropdown--below {
  border: none;
  border-radius: 10px;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);
  margin-top: 2px;
  overflow: hidden;
}

.select2-container--default .select2-results__option {
  padding: 10px;
  font-size: 18px;
  color: #666;
  font-weight: 700;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #ff8300;
}

/* ==========================================================================
   #TAB
   ========================================================================== */
.tab-list {
  list-style: none;
  background: #fa4251;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 20px;
}

.tab-list::after {
  content: "";
  clear: both;
  display: table;
}

@media (max-width: 576px) {
  .tab-list {
    padding: 10px 20px;
  }
}

.tab-list__item {
  float: left;
  border-right: 10px solid #fff;
}
.tab-list__item:last-child {
  border-right: none;
}
.tab-list__item.active {
  position: relative;
}

.tab-list__item.active::after {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(250, 66, 81, 0);
  border-top-color: #fa4251;
  border-width: 8px;
  margin-left: -8px;
}

@media (max-width: 576px) {
  .tab-list__item {
    float: none;
  }
  .tab-list__item.active::after {
    display: none;
  }
}

.tab-list__link {
  display: block;
  font-weight: bold;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  padding: 14px 20px;
}

.tab-list__link:hover {
  color: #fff;
}

@media (max-width: 576px) {
  .tab-list__link {
    padding: 5px 20px;
  }
}

.tab-list .active .tab-list__link {
  color: #fff;
}

.tab-content > .tab-pane {
  display: none;

  padding-bottom: 45px;
}

.tab-content > .tab-pane.active {
  display: block;
}

@media (max-width: 767px) {
  .tab-content > .tab-pane {
    padding: 30px;
    padding-bottom: 45px;
  }
}

/* ==========================================================================
   #TITLE
   ========================================================================== */
.title {
  font-size: 50px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 24px;
}

/* ==========================================================================
   #CARD
   ========================================================================== */
.card-1 {
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);
}

.card-1 .card-body {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);
}


.transfer-list {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.list-container {
  width: 200px;
  margin: 0 10px;
}

.buttons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

button {
  margin: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.list {
  list-style: none;
  padding: 0;
}

.list-item {
  display: flex;
  align-items: center;
  padding: 5px 0;
}

input[type="checkbox"] {
  margin-right: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch-isolated {
  display: flex;
  align-items: center;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;;GAEG;;AAEH;;+EAE+E;AAC/E;EAKE,aAAa;EAGb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EAKE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;+EAE+E;AAC/E;;;EAGE;AACF;EAGE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;;EAEE;AACF;;;;;;;EAOE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE;AACF;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE;AACF;EACE,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;;;AAIA;;+EAE+E;AAC/E;EACE,iBAAiB;AACnB;;AAEA;GACG,gBAAgB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EAIrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE,iFAA+D;AACjE;;AAEA;;+EAE+E;AAC/E;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+EAE+E;AAC/E;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAIhB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,YAAY;EAGZ,gDAAgD;EAGhD,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;IAGE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0DAA0D;EAC1D,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAGE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAGE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EAGE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;;EAEE,aAAa;EACb,SAAS;EACT,YAAY;EAGZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EAId,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;EAGtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EAKzB,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EAKE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EAGX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EAIjB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAIhB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;EAGR,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB;EAGnB,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAKE,0BAA0B;AAC5B;;AAEA;;+EAE+E;AAC/E;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EAKV,aAAa;EAKb,uBAAuB;EAKvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,cAAc;EAId,yBAAyB;AAC3B;;AAEA;EAKE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EAGZ,mBAAmB;EAGnB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,mBAAmB;EAGnB,6BAA6B;EAG7B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;;EAEb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EAGE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAGhB,mBAAmB;EAGnB,gDAAgD;AAClD;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n/* .tab-content:last-child {\n  display: none;\n} */\n \n/* ==========================================================================\n   #GRID\n   ========================================================================== */\n.row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.row-space {\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -moz-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.row-refine {\n  margin: 0 -15px;\n}\n\n.col-2 {\n  width: -webkit-calc((100% - 30px) / 2);\n  width: -moz-calc((100% - 30px) / 2);\n  width: calc((100% - 30px) / 2);\n}\n\n@media (max-width: 767px) {\n  .col-2 {\n    width: 100%;\n  }\n}\n\n/* ==========================================================================\n   #BOX-SIZING\n   ========================================================================== */\n/**\n * More sensible default box-sizing:\n * css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice\n */\nhtml {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n}\n\n*, *:before, *:after {\n  -webkit-box-sizing: inherit;\n  -moz-box-sizing: inherit;\n  box-sizing: inherit;\n}\n\n/* ==========================================================================\n   #RESET\n   ========================================================================== */\n/**\n * A very simple reset that sits on top of Normalize.css.\n */\nbody,\nh1, h2, h3, h4, h5, h6,\nblockquote, p, pre,\ndl, dd, ol, ul,\nfigure,\nhr,\nfieldset, legend {\n  margin: 0;\n  padding: 0;\n}\n\n/**\n * Remove trailing margins from nested lists.\n */\nli > ol,\nli > ul {\n  margin-bottom: 0;\n}\n\n/**\n * Remove default table spacing.\n */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/**\n * 1. Reset Chrome and Firefox behaviour which sets a `min-width: min-content;`\n *    on fieldsets.\n */\nfieldset {\n  min-width: 0;\n  /* [1] */\n  border: 0;\n}\n\n \n\n/* ==========================================================================\n   #PAGE WRAPPER\n   ========================================================================== */\n.page-wrapper {\n  min-height: 100vh;\n}\n\nbody {\n   font-weight: 400;\n  font-size: 14px;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 400;\n}\n\nh1 {\n  font-size: 36px;\n}\n\nh2 {\n  font-size: 30px;\n}\n\nh3 {\n  font-size: 24px;\n}\n\nh4 {\n  font-size: 18px;\n}\n\nh5 {\n  font-size: 15px;\n}\n\nh6 {\n  font-size: 13px;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\na {\n  display: inline-block;\n  text-decoration: none;\n  -webkit-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\na:link {\n  text-decoration: none;\n}\n\na:visited {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\na:active {\n  text-decoration: none;\n}\n\n/* ==========================================================================\n   #BACKGROUND\n   ========================================================================== */\n.bg-img-1 {\n  background: url(\"/public/bg.jpg\") center center/cover no-repeat;\n}\n\n/* ==========================================================================\n   #SPACING\n   ========================================================================== */\n.p-t-15 {\n  padding-top: 15px;\n}\n\n.p-t-5 {\n  padding-top: 5px;\n}\n\n.p-t-275 {\n  padding-top: 275px;\n}\n\n@media (max-width: 767px) {\n  .p-t-275 {\n    padding-top: 120px;\n  }\n}\n\n.p-t-165 {\n  padding-top: 165px;\n}\n\n@media (max-width: 767px) {\n  .p-t-165 {\n    padding-top: 120px;\n  }\n}\n\n.p-b-100 {\n  padding-bottom: 100px;\n}\n\n@media (max-width: 767px) {\n  .p-b-100 {\n    padding-bottom: 250px;\n  }\n}\n\n.m-r-45 {\n  margin-right: 45px;\n}\n\n@media (max-width: 767px) {\n  .m-r-45 {\n    margin-right: 15px;\n  }\n}\n\n.m-t-0 {\n  margin-top: 0;\n}\n\n/* ==========================================================================\n   #WRAPPER\n   ========================================================================== */\n.wrapper {\n  margin: 0 auto;\n}\n\n.wrapper--w680 {\n  max-width: 680px;\n}\n\n/* ==========================================================================\n   #BUTTON\n   ========================================================================== */\n.btn-submit {\n  display: block;\n  margin-top: 32px;\n  width: 100%;\n  line-height: 50px;\n  font-family: inherit;\n  background: #00ad5f;\n  text-transform: uppercase;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  -webkit-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n.btn-submit:hover {\n  background: #00994b;\n}\n\n.m-t-0 {\n  margin-top: 0;\n}\n\n/* ==========================================================================\n   #DATEPICKER\n   ========================================================================== */\n.daterangepicker {\n  display: none;\n  width: 570px;\n  -webkit-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  padding: 30px 35px;\n  padding-top: 27px;\n  padding-bottom: 45px;\n  margin-top: 2px;\n}\n\n@media (max-width: 767px) {\n  .daterangepicker {\n    width: -webkit-calc(100% - 60px);\n    width: -moz-calc(100% - 60px);\n    width: calc(100% - 60px);\n    padding: 25px 0px;\n  }\n}\n\n.daterangepicker:before, .daterangepicker:after {\n  display: none;\n}\n\n.daterangepicker .calendar {\n  margin: 0;\n  width: 235px;\n}\n\n.daterangepicker .calendar th {\n  font-size: 14px;\n  color: #aaa;\n  cursor: default;\n}\n\n.daterangepicker .calendar th.month {\n  font-size: 16px;\n  color: #555;\n  font-weight: 700;\n}\n\n.daterangepicker .calendar th.next, .daterangepicker .calendar th.prev {\n  font-size: 20px;\n  color: #ccc;\n  text-align: center;\n}\n\n.daterangepicker .calendar.right {\n  float: right;\n}\n\n@media (max-width: 767px) {\n  .daterangepicker .calendar {\n    width: 235px;\n    max-width: 270px;\n  }\n  .daterangepicker .calendar.right, .daterangepicker .calendar.left {\n    float: none !important;\n    clear: none !important;\n    margin: 0 auto !important;\n  }\n  .daterangepicker .calendar.left {\n    margin-bottom: 30px !important;\n  }\n}\n\n.daterangepicker .calendar-table {\n  padding: 0;\n}\n\n.daterangepicker .calendar-table .table-condensed thead tr:nth-child(2) th {\n  padding-top: 27px;\n  padding-bottom: 17px;\n}\n\n.daterangepicker.ltr .calendar.left .calendar-table {\n  padding: 0;\n}\n\n.daterangepicker_input {\n  display: none;\n}\n\n.daterangepicker td {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  height: 32px;\n  width: 32px;\n  font-family: \"Lato\", \"Arial\", \"Helvetica Neue\", sans-serif;\n  text-align: center;\n  font-size: 14px;\n  color: #555;\n}\n\n.daterangepicker td.start-date, .daterangepicker td.end-date {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  background: #ffa037;\n}\n\n.daterangepicker td.start-date.end-date {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n\n.daterangepicker td.in-range {\n  background: #ffe1c4;\n}\n\n.daterangepicker td.today {\n  -webkit-border-radius: 50% !important;\n  -moz-border-radius: 50% !important;\n  border-radius: 50% !important;\n  background: #c9c9c9;\n}\n\n.daterangepicker td.today.in-range {\n  -webkit-border-radius: 0 !important;\n  -moz-border-radius: 0 !important;\n  border-radius: 0 !important;\n  background: #ffe1c4;\n}\n\n.daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\n  background: transparent;\n  color: #aaa;\n}\n\n.daterangepicker select {\n  outline: none;\n  font-family: inherit;\n}\n\n.daterangepicker select.monthselect, .daterangepicker select.yearselect {\n  font-size: 14px;\n  padding: 8px 4px;\n}\n\n.daterangepicker td.active,\n.daterangepicker td.active:hover {\n  background: #ffa037;\n}\n\n.dropdown-datepicker {\n  position: relative;\n}\n\n.dropdown-datepicker .daterangepicker {\n  width: 270px;\n  padding: 20px;\n}\n\n/* ==========================================================================\n   #FORM\n   ========================================================================== */\ninput,\ntextarea {\n  outline: none;\n  margin: 0;\n  border: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  width: 100%;\n  font-size: 18px;\n  font-family: inherit;\n}\n\ninput:disabled {\n  background: transparent;\n  cursor: pointer;\n}\n\ntextarea {\n  resize: none;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.input-group {\n  position: relative;\n  border-bottom: 2px solid #cccccc !important;\n}\n\n.input-group-icon {\n  position: relative;\n}\n\n.input-icon {\n  font-size: 24px;\n  color: #808080;\n  position: absolute;\n  line-height: 44px;\n  right: 0;\n  top: 0;\n  width: 42px;\n  background: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n\n.input-icon::before {\n  display: block;\n  -webkit-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n.label {\n  font-size: 12px;\n  color: #999;\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: -3px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.input--style-1 {\n  font-weight: 700;\n  font-size: 18px;\n  padding: 11px 0;\n  color: #555555;\n}\n\n.input--style-1::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #555;\n}\n\n.input--style-1:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #555;\n  opacity: 1;\n}\n\n.input--style-1::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #555;\n  opacity: 1;\n}\n\n.input--style-1:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #555;\n}\n\n.input--style-1:-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #555;\n}\n\n/* CHECKBOX */\n.checkbox-container {\n  display: inline-block;\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 15px;\n  color: #666;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  background-color: transparent;\n  border: 2px solid #ccc;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.checkbox-container input:checked ~ .checkmark {\n  background-color: transparent;\n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.checkbox-container .checkmark:after {\n  left: 4px;\n  top: 2px;\n  width: 7px;\n  height: 10px;\n  border: solid #00ad5f;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n/* ==========================================================================\n   #SELECT\n   ========================================================================== */\n.quantity {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: flex;\n  float: right;\n}\n\n@media (max-width: 575px) {\n  .quantity {\n    float: none;\n    margin-top: 10px;\n  }\n}\n\n.quantity > input {\n  -webkit-appearance: none;\n  width: 55px;\n  text-align: center;\n  font-size: 18px;\n  color: #555;\n  font-weight: 700;\n}\n\n.minus,\n.plus {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  line-height: 26px;\n  text-align: center;\n  border: 2px solid #ccc;\n  font-size: 24px;\n  color: #ccc;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n.minus:hover,\n.plus:hover {\n  background: #ccc;\n  color: #fff;\n}\n\n.list-room {\n  list-style: none;\n  max-height: 324px;\n  overflow-y: auto;\n  padding-right: 20px;\n}\n\n.list-room__item {\n  margin-bottom: 20px;\n}\n\n.list-room__footer {\n  padding-top: 22px;\n  border-top: 1px solid #e5e5e5;\n}\n\n.list-room__name {\n  margin-bottom: 27px;\n  display: block;\n  font-weight: 700;\n  color: #999;\n}\n\n.list-person {\n  list-style: none;\n}\n\n.list-person .list-person__item:last-child {\n  margin-bottom: 0;\n}\n\n.list-person__item {\n  margin-bottom: 34px;\n}\n\n.list-person__item::after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n.list-person__item .name {\n  font-size: 18px;\n  color: #555;\n  font-weight: 700;\n  display: inline-block;\n  margin-top: 5px;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n#btn-add-room {\n  font-family: inherit;\n  font-size: 16px;\n  color: #00ad5f;\n  font-weight: 700;\n  -webkit-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n#btn-add-room:hover {\n  text-decoration: underline;\n}\n\n.dropdown-select {\n  display: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -webkit-calc(100% + 2px);\n  top: -moz-calc(100% + 2px);\n  top: calc(100% + 2px);\n  background: #fff;\n  z-index: 999;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  padding: 30px 45px;\n  padding-right: 25px;\n}\n\n.dropdown-select.show {\n  display: block;\n}\n\n.open .input-icon::before {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n\n/* ==========================================================================\n   #SELECT2\n   ========================================================================== */\n.select--no-search .select2-search {\n  display: none !important;\n}\n\n.rs-select2 {\n  width: 100%;\n}\n\n.rs-select2 .select2-container {\n  width: 100% !important;\n  outline: none;\n}\n\n.rs-select2 .select2-container .select2-selection--single {\n  outline: none;\n  border: none;\n  height: 44px;\n}\n\n.rs-select2 .select2-container .select2-selection--single .select2-selection__rendered {\n  line-height: 44px;\n  padding-left: 0;\n  color: #555;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.rs-select2 .select2-container .select2-selection--single .select2-selection__arrow {\n  height: 44px;\n  right: 4px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -moz-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.rs-select2 .select2-container .select2-selection--single .select2-selection__arrow b {\n  display: none;\n}\n\n.rs-select2 .select2-container .select2-selection--single .select2-selection__arrow:after {\n  font-family: \"Material-Design-Iconic-Font\";\n  content: '\\f2f9';\n  font-size: 24px;\n  color: #808080;\n  -webkit-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n.rs-select2 .select2-container.select2-container--open .select2-selection--single .select2-selection__arrow::after {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n\n.select2-container--open .select2-dropdown--below {\n  border: none;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  margin-top: 2px;\n  overflow: hidden;\n}\n\n.select2-container--default .select2-results__option {\n  padding: 10px;\n  font-size: 18px;\n  color: #666;\n  font-weight: 700;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background: #ff8300;\n}\n\n/* ==========================================================================\n   #TAB\n   ========================================================================== */\n.tab-list {\n  list-style: none;\n  background: #fa4251;\n  -webkit-border-top-right-radius: 10px;\n  -moz-border-radius-topright: 10px;\n  border-top-right-radius: 10px;\n  -webkit-border-top-left-radius: 10px;\n  -moz-border-radius-topleft: 10px;\n  border-top-left-radius: 10px;\n  padding: 0 20px;\n}\n\n.tab-list::after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n@media (max-width: 576px) {\n  .tab-list {\n    padding: 10px 20px;\n  }\n}\n\n.tab-list__item {\n  float: left;\n  border-right: 10px solid #fff;\n}\n.tab-list__item:last-child {\n  border-right: none;\n}\n.tab-list__item.active {\n  position: relative;\n}\n\n.tab-list__item.active::after {\n  top: 100%;\n  left: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-color: rgba(250, 66, 81, 0);\n  border-top-color: #fa4251;\n  border-width: 8px;\n  margin-left: -8px;\n}\n\n@media (max-width: 576px) {\n  .tab-list__item {\n    float: none;\n  }\n  .tab-list__item.active::after {\n    display: none;\n  }\n}\n\n.tab-list__link {\n  display: block;\n  font-weight: bold;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  padding: 14px 20px;\n}\n\n.tab-list__link:hover {\n  color: #fff;\n}\n\n@media (max-width: 576px) {\n  .tab-list__link {\n    padding: 5px 20px;\n  }\n}\n\n.tab-list .active .tab-list__link {\n  color: #fff;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n\n  padding-bottom: 45px;\n}\n\n.tab-content > .tab-pane.active {\n  display: block;\n}\n\n@media (max-width: 767px) {\n  .tab-content > .tab-pane {\n    padding: 30px;\n    padding-bottom: 45px;\n  }\n}\n\n/* ==========================================================================\n   #TITLE\n   ========================================================================== */\n.title {\n  font-size: 50px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  color: #fff;\n  margin-bottom: 24px;\n}\n\n/* ==========================================================================\n   #CARD\n   ========================================================================== */\n.card-1 {\n  -webkit-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n}\n\n.card-1 .card-body {\n  background: #fff;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);\n}\n\n\n.transfer-list {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.list-container {\n  width: 200px;\n  margin: 0 10px;\n}\n\n.buttons-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nbutton {\n  margin: 5px;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.list {\n  list-style: none;\n  padding: 0;\n}\n\n.list-item {\n  display: flex;\n  align-items: center;\n  padding: 5px 0;\n}\n\ninput[type=\"checkbox\"] {\n  margin-right: 10px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.switch-isolated {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
